var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcFacility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3.5C7 2.39543 7.89543 1.5 9 1.5H15.5C16.6046 1.5 17.5 2.39543 17.5 3.5V5.5H18C19.1046 5.5 20 6.39543 20 7.5V21H22C22.5523 21 23 21.4477 23 22C23 22.5523 22.5523 23 22 23H2C1.44772 23 1 22.5523 1 22C1 21.4477 1.44772 21 2 21H4V8.5C4 6.84315 5.34315 5.5 7 5.5V3.5ZM9 5.5H13.5C14.0523 5.5 14.5 5.94772 14.5 6.5C14.5 7.05228 14.0523 7.5 13.5 7.5H7C6.44772 7.5 6 7.94772 6 8.5V21H18V7.5H17.5C16.3954 7.5 15.5 6.60457 15.5 5.5V3.5H9V5.5ZM7.5 12.5C7.5 11.9477 7.94772 11.5 8.5 11.5H9.5C10.0523 11.5 10.5 11.9477 10.5 12.5C10.5 13.0523 10.0523 13.5 9.5 13.5H8.5C7.94772 13.5 7.5 13.0523 7.5 12.5ZM13.5 12.5C13.5 11.9477 13.9477 11.5 14.5 11.5H15.5C16.0523 11.5 16.5 11.9477 16.5 12.5C16.5 13.0523 16.0523 13.5 15.5 13.5H14.5C13.9477 13.5 13.5 13.0523 13.5 12.5ZM7.5 17C7.5 16.4477 7.94772 16 8.5 16H9.5C10.0523 16 10.5 16.4477 10.5 17C10.5 17.5523 10.0523 18 9.5 18H8.5C7.94772 18 7.5 17.5523 7.5 17ZM13.5 17C13.5 16.4477 13.9477 16 14.5 16H15.5C16.0523 16 16.5 16.4477 16.5 17C16.5 17.5523 16.0523 18 15.5 18H14.5C13.9477 18 13.5 17.5523 13.5 17Z",
    fill: "#292F4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcFacility);
export default __webpack_public_path__ + "static/media/ic_facility.41f8bcdb337edca1ff11939905daa7a2.svg";
export { ForwardRef as ReactComponent };